// @flow

import React from "react";
import { v4 as uuid } from "uuid";

import widgets from "./widgets";
import type { SchemaTableWidgetProps } from "./types";

import "./schema-table.scss";

const resolveDisplayValue = (props: SchemaTableWidgetProps<any>) => {
  let displayValue = props.data;

  if (typeof props.data === "object" && props.data instanceof Date) {
    displayValue = props.data.toString();
  }

  let oneOfConst = displayValue;
  if (props.type === "object") {
    oneOfConst = (props.data || {}).id;
  }

  if (props.oneOf) {
    displayValue = (props.oneOf.find(o => o.const === oneOfConst) || {}).title;
  }

  return displayValue;
};

const SchemaTableCell = (props: SchemaTableWidgetProps<any>) => {
  if (props.widget && widgets[props.widget]) {
    const Widget = widgets[props.widget];

    const { editable } = props.options || {};
    const active = props.active && (editable === undefined || editable);
    const id = uuid();

    if (Widget) {
      return (
        <Widget
          {...props}
          id={id}
          row={props.row}
          data={props.data}
          active={active}
          onChange={props.onChange}
        />
      );
    }
  }

  return <div>{resolveDisplayValue(props)}</div>;
};

export default SchemaTableCell;
